var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.68799C5.34315 3.68799 4 5.03113 4 6.68799V19.688C4 21.3448 5.34315 22.688 7 22.688H17C18.6569 22.688 20 21.3448 20 19.688V6.68799C20 5.03113 18.6569 3.68799 17 3.68799H7Z",
    fill: "#EDDFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11.688C8.44772 11.688 8 12.1357 8 12.688C8 13.2403 8.44772 13.688 9 13.688H15C15.5523 13.688 16 13.2403 16 12.688C16 12.1357 15.5523 11.688 15 11.688H9ZM9 15.688C8.44772 15.688 8 16.1357 8 16.688C8 17.2403 8.44772 17.688 9 17.688H13C13.5523 17.688 14 17.2403 14 16.688C14 16.1357 13.5523 15.688 13 15.688H9Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.68799C9 3.1357 9.44772 2.68799 10 2.68799H14C14.5523 2.68799 15 3.1357 15 3.68799V4.68799C15 5.24027 14.5523 5.68799 14 5.68799H10C9.44772 5.68799 9 5.24027 9 4.68799V3.68799Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalHistory);
export default __webpack_public_path__ + "static/media/medical-history.36e66613aeb1a63f202f06ed2f6cadba.svg";
export { ForwardRef as ReactComponent };